export default {
  SET_CONSULT(state, data) {
    state.consult = data;
  },

  SET_DOCUMENTS_CONSULTED(state, data) {
    state.documentsConsulted = data;
  },

  SET_AGENDA(state, data) {
    state.agenda = data;
  },
};
